// A schematic, rather than a simulated app screen, keeps the empty state honest.
export function DeviceIllustration({ className }: { className?: string }) {
  return (
    <svg aria-hidden="true" viewBox="0 0 320 340" fill="none" className={className}>
      <g className="text-border" stroke="currentColor" strokeWidth="1">
        <path
          d="M16 90h288M16 170h288M16 250h288M80 26v288M160 26v288M240 26v288"
          strokeDasharray="2 6"
        />
        <ellipse cx="160" cy="174" rx="144" ry="70" transform="rotate(-28 160 174)" />
        <path d="M24 314h272" />
      </g>
      <rect
        x="93"
        y="28"
        width="134"
        height="274"
        rx="26"
        className="fill-background stroke-muted-foreground/40"
      />
      <rect x="99" y="34" width="122" height="262" rx="21" className="fill-card stroke-border" />
      <rect x="139" y="43" width="42" height="7" rx="3.5" className="fill-background" />
      <path
        d="M90 87v22m0 10v22m140-39v34"
        className="stroke-muted-foreground/40"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <g
        className="text-brand"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M142 147h-10v34h10m36-34h10v34h-10" />
        <path d="m154 155 10 9-10 9" />
      </g>
      <path
        d="M135 203h50m-42 8h34"
        className="stroke-muted-foreground/30"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M142 285h36"
        className="stroke-muted-foreground/40"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <circle cx="278" cy="119" r="5" className="fill-brand" />
      <circle cx="42" cy="230" r="3" className="fill-muted-foreground/50" />
      <g className="stroke-muted-foreground/40">
        <path d="M39 71h8m-4-4v8M269 279h8m-4-4v8" />
      </g>
    </svg>
  );
}
